//Componente para el bloque de título y con fondo de color
const styles = {
  header: {
    backgroundColor: "var(--color-primary)",
  },
  headerTitle: {
    textAlign: "left",
    color: "white",
    whiteSpace: "normal",
    overflowWrap: "break-word",
    wordBreak: "normal",
  },
};

function TextHeader({title}) {
  
  return (
    <div style={styles.header} className="m-0 py-4 px-md-5">
      <p className="h1 fw-bold p-4 p-md-4" style={styles.headerTitle}>{title}</p>
    </div>
  );
}
export default TextHeader;